// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';           // ← make sure this points to your updated App.jsx
import './index.css';              // ← Tailwind imports

ReactDOM
  .createRoot(document.getElementById('root'))
  .render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
